<template>
  <div class="ag-status-name-value">
    <div class="component">
      Lignes : <span class="text-black">{{ displayedRowCount }}</span>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      displayedRowCount: 0
    }
  },
  mounted () {
    this.updateDisplayedRowCount()
    this.params.api.addEventListener('modelUpdated', this.updateDisplayedRowCount)
  },
  beforeDestroy () {
    this.params.api.removeEventListener('modelUpdated', this.updateDisplayedRowCount)
  },
  methods: {
    init (params) {
      this.params = params
      this.updateDisplayedRowCount()
    },
    updateDisplayedRowCount () {
      if (this.params && this.params.api) {
        this.displayedRowCount = this.params.api.getDisplayedRowCount()
      }
    }
  }
}
</script>
